export default "__VITE_ASSET__B52CJON7__"